export interface Product {
  id: number
  name: string
  price: string
  priceNum: number
  image: string
  category: string
  vehicle: string
  sku: string
  description: string
  features: string[]
  specs: { label: string; value: string }[]
  inStock: boolean
}

export const products: Product[] = [
  {
    id: 1,
    name: '6" Pro-Stage 1 Lift Kit System',
    price: '$1,299.00',
    priceNum: 1299,
    image:
      'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?auto=format&fit=crop&w=800&q=80',
    category: 'Lift Kits',
    vehicle: 'Ford F-150',
    sku: 'POD-LK-F150-06',
    description:
      'The ultimate suspension upgrade for your F-150. Our 6" Pro-Stage 1 system is engineered to provide superior off-road performance while maintaining excellent street manners. Features high-clearance crossmembers and precision-valved shocks.',
    features: [
      'High-clearance crossmember design',
      'Precision-valved nitrogen shocks included',
      'Ductile iron steering knuckles',
      'Fabricated rear lift blocks with integrated bump stops',
      'Maintains factory ride quality',
    ],
    specs: [
      { label: 'Lift Height', value: '6 Inches' },
      { label: 'Max Tire Size', value: '35x12.50' },
      { label: 'Install Time', value: '6-8 Hours' },
      { label: 'Material', value: 'Steel / Ductile Iron' },
      { label: 'Warranty', value: 'Lifetime Structural' },
    ],
    inStock: true,
  },
  {
    id: 2,
    name: 'Performance Series 2.0 Reservoir Shocks',
    price: '$189.99',
    priceNum: 189.99,
    image:
      'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?auto=format&fit=crop&w=800&q=80',
    category: 'Shocks & Struts',
    vehicle: 'Universal',
    sku: 'POD-SHK-20-RES',
    description:
      'Race-proven performance in a bolt-on package. These 2.0" body remote reservoir shocks provide increased cooling capacity and consistent damping in the roughest terrain. Fully rebuildable and revalvable.',
    features: [
      '2.0" impact extruded aluminum body',
      'External reservoir for increased oil capacity',
      '5/8" hard chrome plated heat-treated alloy steel shaft',
      'Race-developed high-flow piston design',
      'Redundant sealing pack system',
    ],
    specs: [
      { label: 'Body Diameter', value: '2.0 Inches' },
      { label: 'Travel', value: '10 Inches' },
      { label: 'Mount Type', value: 'Eyelet / Eyelet' },
      { label: 'Finish', value: 'Clear Anodized' },
      { label: 'Sold As', value: 'Single' },
    ],
    inStock: true,
  },
  {
    id: 3,
    name: 'Heavy Duty Upper Control Arms',
    price: '$449.95',
    priceNum: 449.95,
    image:
      'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?auto=format&fit=crop&w=800&q=80',
    category: 'Control Arms',
    vehicle: 'Chevy Silverado',
    sku: 'POD-UCA-GM-1500',
    description:
      'Correct your suspension geometry and increase wheel travel with our boxed upper control arms. Featuring uniball joints for maximum articulation and strength compared to factory ball joints.',
    features: [
      'Boxed steel construction for maximum strength',
      '1" Stainless steel uniballs',
      'Polyurethane bushings with grease zerks',
      'Corrects caster for lifted applications',
      'Durable powder coat finish',
    ],
    specs: [
      { label: 'Construction', value: 'Boxed Steel' },
      { label: 'Joint Type', value: '1" Uniball' },
      { label: 'Finish', value: 'Textured Black Powder Coat' },
      { label: 'Fitment', value: '2019+ Silverado 1500' },
      { label: 'Warranty', value: 'Limited Lifetime' },
    ],
    inStock: true,
  },
  {
    id: 4,
    name: 'Dual Steering Stabilizer Kit',
    price: '$229.50',
    priceNum: 229.5,
    image:
      'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?auto=format&fit=crop&w=800&q=80',
    category: 'Steering',
    vehicle: 'Ram 2500/3500',
    sku: 'POD-SS-RAM-HD',
    description:
      'Eliminate steering wander and feedback with our dual steering stabilizer kit. Essential for trucks running larger tires, this kit mounts two stabilizers in an opposing configuration to perfectly damp steering inputs.',
    features: [
      'Heavy-duty 1/4" steel mounting brackets',
      'Includes two Pro-Series cylinders',
      'Bolt-on installation',
      'Reduces steering wheel vibration',
      'Improves handling on and off-road',
    ],
    specs: [
      { label: 'Position', value: 'Front Axle' },
      { label: 'Bracket Material', value: '1/4" Steel' },
      { label: 'Finish', value: 'Black Powder Coat' },
      { label: 'Hardware', value: 'Grade 8 Included' },
      { label: 'Fitment', value: '2014+ Ram 2500/3500' },
    ],
    inStock: true,
  },
  {
    id: 5,
    name: '2.5" Leveling Kit',
    price: '$129.00',
    priceNum: 129.0,
    image:
      'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?auto=format&fit=crop&w=800&q=80',
    category: 'Leveling Kits',
    vehicle: 'Ford F-150',
    sku: 'POD-LVL-F150',
    description:
      'Level the stance of your truck and fit up to 33" tires with our billet aluminum leveling spacers. Machined in-house from 6061-T6 aluminum and anodized for corrosion resistance.',
    features: [
      'CNC machined 6061-T6 billet aluminum',
      'Anodized black finish',
      'No strut disassembly required',
      'Maintains factory ride quality',
      'Includes all necessary hardware',
    ],
    specs: [
      { label: 'Lift Height', value: '2.5 Inches' },
      { label: 'Material', value: '6061-T6 Aluminum' },
      { label: 'Install Time', value: '2-3 Hours' },
      { label: 'Max Tire', value: '33 Inches' },
      { label: 'Warranty', value: 'Lifetime' },
    ],
    inStock: true,
  },
  {
    id: 6,
    name: 'Adjustable Track Bar',
    price: '$289.00',
    priceNum: 289.0,
    image:
      'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?auto=format&fit=crop&w=800&q=80',
    category: 'Suspension',
    vehicle: 'Jeep Wrangler',
    sku: 'POD-TB-JK-FR',
    description:
      'Center your front axle after lifting your Jeep with our heavy-duty adjustable track bar. Constructed from 1.5" solid chromoly steel for unbeatable strength.',
    features: [
      '1.5" Solid Chromoly Steel',
      'Adjustable while mounted on vehicle',
      'High-misalignment rod ends',
      'Eliminates death wobble',
      'Direct bolt-on replacement',
    ],
    specs: [
      { label: 'Material', value: '4140 Chromoly' },
      { label: 'Diameter', value: '1.5 Inches' },
      { label: 'Adjustment', value: 'Double Adjustable' },
      { label: 'Bushings', value: 'Polyurethane' },
      { label: 'Fitment', value: '2007-2018 Wrangler JK' },
    ],
    inStock: true,
  },
  {
    id: 7,
    name: '4" Performance Lift System',
    price: '$999.00',
    priceNum: 999.0,
    image:
      'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?auto=format&fit=crop&w=800&q=80',
    category: 'Lift Kits',
    vehicle: 'Toyota Tacoma',
    sku: 'POD-LK-TACO-04',
    description:
      'Gain ground clearance and aggressive looks for your Tacoma. This complete system includes extended steering knuckles, crossmembers, and rear blocks to lift your truck 4 inches correctly.',
    features: [
      'Extended ductile iron knuckles',
      'Heavy duty crossmembers',
      'Differential drop brackets included',
      'Rear lift blocks and u-bolts',
      'FMVSS 126 Compliant',
    ],
    specs: [
      { label: 'Lift Height', value: '4 Inches' },
      { label: 'Max Tire', value: '33 Inches' },
      { label: 'Shocks', value: 'Included (Rear)' },
      { label: 'Cutting Required', value: 'Yes' },
      { label: 'Warranty', value: 'Lifetime Structural' },
    ],
    inStock: true,
  },
  {
    id: 8,
    name: 'Rear Leaf Spring Pack',
    price: '$599.00',
    priceNum: 599.0,
    image:
      'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?auto=format&fit=crop&w=800&q=80',
    category: 'Suspension',
    vehicle: 'Toyota Tacoma',
    sku: 'POD-LS-TACO-RR',
    description:
      'Replace your sagging factory leaf springs with our heavy-duty progressive rate pack. Designed to provide 2" of lift and increase load carrying capacity without sacrificing ride quality.',
    features: [
      'Progressive rate design',
      'Diamond cut leaf ends',
      'Teflon anti-friction pads',
      'Military wrap main eye',
      'Includes new u-bolts',
    ],
    specs: [
      { label: 'Lift Height', value: '2 Inches' },
      { label: 'Capacity', value: '+400 lbs over stock' },
      { label: 'Type', value: 'Full Replacement Pack' },
      { label: 'Bushings', value: 'Rubber Included' },
      { label: 'Sold As', value: 'Pair' },
    ],
    inStock: false,
  },
  {
    id: 9,
    name: 'Front Coilover Conversion',
    price: '$1,450.00',
    priceNum: 1450.0,
    image:
      'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?auto=format&fit=crop&w=800&q=80',
    category: 'Shocks & Struts',
    vehicle: 'Ford F-150',
    sku: 'POD-CO-F150-25',
    description:
      'Convert your front suspension to a true coilover system. These 2.5" diameter coilovers offer ride height adjustability from 0-3" of lift and superior damping control.',
    features: [
      '2.5" Honed seamless alloy body',
      'Eibach racing coil springs',
      'Adjustable ride height (0-3")',
      'Billet aluminum components',
      'Direct bolt-in installation',
    ],
    specs: [
      { label: 'Body Size', value: '2.5 Inches' },
      { label: 'Lift Range', value: '0-3 Inches' },
      { label: 'Spring Rate', value: '600 lbs/in' },
      { label: 'Rebuildable', value: 'Yes' },
      { label: 'Valving', value: 'Vehicle Specific' },
    ],
    inStock: true,
  },
  {
    id: 10,
    name: 'Differential Cover Guard',
    price: '$125.99',
    priceNum: 125.99,
    image:
      'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?auto=format&fit=crop&w=800&q=80',
    category: 'Accessories',
    vehicle: 'Universal',
    sku: 'POD-DIFF-DANA44',
    description:
      'Protect your vulnerable differential cover from rocks and stumps. Laser cut from 3/8" steel plate and formed to fit perfectly over your factory or aftermarket diff cover.',
    features: [
      '3/8" Steel plate construction',
      'Laser cut and CNC bent',
      'Protects lower lip of differential',
      'Drain hole access retained',
      'Includes Grade 8 hardware',
    ],
    specs: [
      { label: 'Material', value: '3/8" Steel' },
      { label: 'Axle', value: 'Dana 44' },
      { label: 'Finish', value: 'Raw or Powder Coat' },
      { label: 'Weight', value: '12 lbs' },
      { label: 'Origin', value: 'Made in USA' },
    ],
    inStock: true,
  },
  {
    id: 11,
    name: 'Sway Bar Disconnects',
    price: '$149.00',
    priceNum: 149.0,
    image:
      'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?auto=format&fit=crop&w=800&q=80',
    category: 'Suspension',
    vehicle: 'Jeep Wrangler',
    sku: 'POD-SBD-JK',
    description:
      'Unlock the full articulation potential of your Jeep with our quick disconnect sway bar links. Easily disconnect your front sway bar for off-road use and reconnect for the drive home.',
    features: [
      'Quick pull pin design',
      'Adjustable length',
      'Greaseable polyurethane bushings',
      'Stainless steel mounting posts',
      'Includes frame storage brackets',
    ],
    specs: [
      { label: 'Lift Range', value: '2.5-6 Inches' },
      { label: 'Material', value: 'Steel / Poly' },
      { label: 'Operation', value: 'Manual Disconnect' },
      { label: 'Fitment', value: '2007-2018 Wrangler JK' },
      { label: 'Finish', value: 'Zinc Plated' },
    ],
    inStock: true,
  },
  {
    id: 12,
    name: 'Billet Tie Rod Kit',
    price: '$389.00',
    priceNum: 389.0,
    image:
      'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?auto=format&fit=crop&w=800&q=80',
    category: 'Steering',
    vehicle: 'Ford Bronco',
    sku: 'POD-TR-BRONCO',
    description:
      'Replace the weak factory tie rods with our massive billet aluminum kit. Designed to withstand the abuse of large tires and hard off-road use without bending or breaking.',
    features: [
      'Machined from 7075-T6 Aluminum',
      'Hex design for easy adjustment',
      'Heavy duty inner and outer joints',
      'Direct replacement',
      'Anodized finish',
    ],
    specs: [
      { label: 'Material', value: '7075-T6 Aluminum' },
      { label: 'Diameter', value: '1.5 Inches' },
      { label: 'Joints', value: 'FK Rod Ends' },
      { label: 'Fitment', value: '2021+ Bronco' },
      { label: 'Warranty', value: 'Lifetime' },
    ],
    inStock: true,
  },
]
